<template>
  <div class="editBG pt-3 mt-4" style="min-height:100%; margin:0 auto;">
    <v-toolbar class="elevation-1 editBG mt-2">
      <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn>
      <v-toolbar-title>{{ contact.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon :to="{ name: 'EditContact', params: { id: contact.id, contact: contact } }">
        <v-icon>edit</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 md6><strong>Category:</strong> {{ contact.category || '—' }}</v-flex>
        <v-flex xs12 md6><strong>Company:</strong> {{ contact.company || '—' }}</v-flex>
        <v-flex xs12 md6><strong>First name:</strong> {{ contact.first_name || '—' }}</v-flex>
        <v-flex xs12 md6><strong>Last name:</strong> {{ contact.last_name || '—' }}</v-flex>
        <contact-usage-table :usages="contact.usages || {}"></contact-usage-table>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import ContactUsageTable from '@/components/contacts/ContactUsageTable'

export default {
  components: { ContactUsageTable },
  data () {
    return { contact: {} }
  },
  mounted () {
    axios
      .get(`${this.$globals.apiserver}/contacts/${this.$route.params.id}.json`)
      .then(response => { this.contact = response.data })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contacts/ViewContact.vue